type ArchiveTypes = 'pdf' | 'csv';

interface CreateLinkToDownloadParams {
  data: Blob;
  filename: string;
  archiveType: ArchiveTypes;
}

export const createLinkToDownloadBlob = ({
  data,
  filename,
  archiveType,
}: CreateLinkToDownloadParams) => {
  const url = window.URL.createObjectURL(new Blob([data], { type: 'application/csv' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${filename}.${archiveType}`);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
